import store from "../store/index";

const RETURN_KEY = "expiredSessionReturn";

function safeReturnPath(path) {
  return typeof path === "string" && /^\/(?!\/)/.test(path)
    && !/[\\\s]/.test(path)
    && !/^\/(?:login|register|forgetPwd|changePwd)(?:[/?#]|$)/i.test(path);
}

export function expireSession(error) {
  if (!error.response || error.response.status !== 401) return false;
  const headers = error.config && error.config.headers;
  const sentToken = headers && headers.token;
  const currentToken = store.state.token || localStorage.getItem("token");
  // A late failure from an old session must not log out a newly signed-in user.
  if (!sentToken || sentToken !== currentToken) return false;
  store.commit("logout", {});
  const path = window.location.hash.slice(1);
  if (safeReturnPath(path)) sessionStorage.setItem(RETURN_KEY, path);
  return true;
}

export function loginLocation(path) {
  return { path: "/login", query: { redirect: safeReturnPath(path) ? path : "/" } };
}

export function sessionReturnPath(router, redirect) {
  // An explicit login entry takes priority over a previous expired session.
  const path = redirect === undefined ? sessionStorage.getItem(RETURN_KEY) : redirect;
  if (!safeReturnPath(path)) return "/";
  const route = router.resolve(path).route;
  return route.matched.length && route.name !== "NotFound404"
    && safeReturnPath(route.fullPath || path) ? path : "/";
}

export function clearSessionReturn() {
  sessionStorage.removeItem(RETURN_KEY);
}
